export const TiposFactura = [
    {
        id: 1,
        value: 'Emitidas'
    },
    {
        id: 2,
        value: 'Recibidas'
    }
];


export interface TiposFacturaPLANTILLAS {
    id: number;
    value: string;
};

export const TiposDeFacturaPLANTILLAEnum: TiposFacturaPLANTILLAS[] = [
    {
        id: 1,
        value: 'Emitidas',
    },
    {
        id: 2,
        value: 'Recibidas'
    }
];